{
  "types": ["aka", "birth", "married", "maiden", "immigrant", "other"],
  "fallback": "aka",
  "ookBekendAls": ["aka", "other"]
}
